import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './App.css';
import { Toaster } from './components/ui/toaster';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import FeaturesSection from './components/FeaturesSection';
import CustomsClearanceSection from './components/CustomsClearanceSection';
import TrackingSection from './components/TrackingSection';
import PricingSection from './components/PricingSection';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import ScrollAnimations from './components/ScrollAnimations';
import PopularShippingServicesSection from './components/PopularShippingServicesSection';
import CitiesWeServeSection from './components/CitiesWeServeSection';
import DocumentLayout from './layouts/DocumentLayout';
import ScrollToTop from './components/ScrollToTop';
import FAQPage from './pages/FAQPage';
import PartnerPage from './pages/PartnerPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsConditionsPage from './pages/TermsConditionsPage';
import CustomsDeclarationPage from './pages/CustomsDeclarationPage';
import SenderReceiverFormPage from './pages/SenderReceiverFormPage';
import ShippingDestinationsPage from './pages/ShippingDestinationsPage';
import RelocationPage from './pages/RelocationPage';
import ActualWeightVsVolumetricWeightPage from './pages/ActualWeightVsVolumetricWeightPage';
import VolumetricWeightCalculatorPage from './pages/VolumetricWeightCalculatorPage';
import ShippingToIndiaPage from './pages/ShippingToIndiaPage';
import InternationalShippingBramptonPage from './pages/InternationalShippingBramptonPage';
import InternationalCourierTorontoPage from './pages/InternationalCourierTorontoPage';
import InternationalShippingMississaugaPage from './pages/InternationalShippingMississaugaPage';
import InternationalShippingSurreyPage from './pages/InternationalShippingSurreyPage';
import InternationalShippingVancouverPage from './pages/InternationalShippingVancouverPage';
import InternationalShippingNovaScotiaPage from './pages/InternationalShippingNovaScotiaPage';
import CheapShippingCanadaToIndiaPage from './pages/CheapShippingCanadaToIndiaPage';
import RelocationShippingCanadaToIndiaPage from './pages/RelocationShippingCanadaToIndiaPage';
import ShippingCostCanadaToIndiaPage from './pages/ShippingCostCanadaToIndiaPage';
import TrackShipmentPage from './pages/TrackShipmentPage';
import DropOffLocationsPage from './pages/DropOffLocationsPage';
import ContactPage from './pages/ContactPage';
import ServicesPage from './pages/ServicesPage';
import SchedulePickupPage from './pages/SchedulePickupPage';
// New SEO Pages - Phase 1 & 2
import DocumentsToIndiaPage from './pages/DocumentsToIndiaPage';
import ShipSuitcaseCanadaToIndiaPage from './pages/ShipSuitcaseCanadaToIndiaPage';
import StudentShippingCanadaToIndiaPage from './pages/StudentShippingCanadaToIndiaPage';
import TwentyThreeKgParcelPage from './pages/TwentyThreeKgParcelPage';
// City-to-India Pages
import BramptonToIndiaPage from './pages/BramptonToIndiaPage';
import TorontoToIndiaPage from './pages/TorontoToIndiaPage';
import MississaugaToIndiaPage from './pages/MississaugaToIndiaPage';
import HamiltonToIndiaPage from './pages/HamiltonToIndiaPage';
import VaughanToIndiaPage from './pages/VaughanToIndiaPage';
import MarkhamToIndiaPage from './pages/MarkhamToIndiaPage';
import RichmondHillToIndiaPage from './pages/RichmondHillToIndiaPage';
import KitchenerToIndiaPage from './pages/KitchenerToIndiaPage';
import WaterlooToIndiaPage from './pages/WaterlooToIndiaPage';
import OakvilleToIndiaPage from './pages/OakvilleToIndiaPage';
import CalgaryToIndiaPage from './pages/CalgaryToIndiaPage';
// International Destination Pages
import ShippingCanadaToUSAPage from './pages/ShippingCanadaToUSAPage';
import ShippingCanadaToUKPage from './pages/ShippingCanadaToUKPage';
import ShippingCanadaToUAEPage from './pages/ShippingCanadaToUAEPage';
import ShippingCanadaToAustraliaPage from './pages/ShippingCanadaToAustraliaPage';
import ShippingCanadaToPakistanPage from './pages/ShippingCanadaToPakistanPage';
import ShippingCanadaToNepalPage from './pages/ShippingCanadaToNepalPage';
import ShippingCanadaToBangladeshPage from './pages/ShippingCanadaToBangladeshPage';
import ShippingCanadaToGermanyPage from './pages/ShippingCanadaToGermanyPage';
import ShippingCanadaToFrancePage from './pages/ShippingCanadaToFrancePage';
// Specialized Service Pages
import ExcessBaggageShippingPage from './pages/ExcessBaggageShippingPage';
import HouseholdGoodsShippingPage from './pages/HouseholdGoodsShippingPage';
import BusinessShippingPage from './pages/BusinessShippingPage';
// Guide Pages
import ShippingCostGuidePage from './pages/ShippingCostGuidePage';
import CustomsDutiesGuidePage from './pages/CustomsDutiesGuidePage';
import PackagingGuidePage from './pages/PackagingGuidePage';
import ProhibitedItemsGuidePage from './pages/ProhibitedItemsGuidePage';
import SupplementsProteinShippingPage from './pages/SupplementsProteinShippingPage';
import ElectronicsBatteryShippingPage from './pages/ElectronicsBatteryShippingPage';
// New Destination Pages
import ShippingCanadaToUkrainePage from './pages/ShippingCanadaToUkrainePage';
import ShippingCanadaToPhilippinesPage from './pages/ShippingCanadaToPhilippinesPage';
import ShippingCanadaToAfricaPage from './pages/ShippingCanadaToAfricaPage';
import ShippingCanadaToCaribbeanPage from './pages/ShippingCanadaToCaribbeanPage';
import InternationalPerfumeShippingPage from './pages/InternationalPerfumeShippingPage';
import InternationalBarrelShippingPage from './pages/InternationalBarrelShippingPage';
import BlogListPage from './pages/BlogListPage';
import BlogArticlePage from './pages/BlogArticlePage';

const HomePage = ({ onTrack }) => (
  <>
    <Helmet>
      <title>Shippzy Canada | International Shipping & Courier Services</title>
      <meta name="description" content="Shippzy provides affordable international shipping from Canada. Compare DHL, FedEx, UPS & more. Free pickup, fast delivery, real-time tracking, and worldwide shipping." />
      <link rel="canonical" href="https://www.shippzy.ca/" />
    </Helmet>
    <HeroSection onTrack={onTrack} />
    <ServicesSection />
    <FeaturesSection />
    <CustomsClearanceSection />
    <TrackingSection />
    <PopularShippingServicesSection />
    <PricingSection />
    <TestimonialsSection />
    <CitiesWeServeSection />
    <ContactSection />
  </>
);

function App() {
  const [trackingNumber, setTrackingNumber] = useState('');

  // Initialize AOS for scroll animations
  useEffect(() => {
    AOS.init({
      duration: 1000, // Increased from 800 for more visible animations
      once: false,
      mirror: true,
      easing: 'ease-out-cubic',
      offset: 50, // Reduced from 100 for earlier trigger
      delay: 0,
    });
    
    // Refresh AOS on route change
    AOS.refresh();
  }, []);

  const handleTrack = (number) => {
    setTrackingNumber(number);
    // Scroll to tracking section
    const trackSection = document.getElementById('track');
    if (trackSection) {
      trackSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Router>
      <ScrollToTop />
      <div className="App relative">
        <ScrollAnimations />
        {/* Global padding-top to account for fixed navbar (h-20 = 80px) */}
        <div className="relative z-10 pt-20">
          <Routes>
            {/* Standard Routes - with Navbar and Footer */}
            <Route path="/" element={
              <>
                <Navbar />
                <HomePage onTrack={handleTrack} />
                <Footer />
              </>
            } />
            <Route path="/faq" element={
              <>
                <Navbar />
                <FAQPage />
                <Footer />
              </>
            } />
            <Route path="/partner" element={
              <>
                <Navbar />
                <PartnerPage />
                <Footer />
              </>
            } />
            <Route path="/relocation" element={
              <>
                <Navbar />
                <RelocationPage />
                <Footer />
              </>
            } />
            <Route path="/actual-weight-vs-volumetric-weight" element={
              <>
                <Navbar />
                <VolumetricWeightCalculatorPage />
                <Footer />
              </>
            } />
            <Route path="/shipping-to-india-from-canada" element={
              <>
                <Navbar />
                <ShippingToIndiaPage />
                <Footer />
              </>
            } />
            <Route path="/international-shipping-brampton" element={
              <>
                <Navbar />
                <InternationalShippingBramptonPage />
                <Footer />
              </>
            } />
            <Route path="/international-courier-toronto" element={
              <>
                <Navbar />
                <InternationalCourierTorontoPage />
                <Footer />
              </>
            } />
            <Route path="/international-shipping-mississauga" element={
              <>
                <Navbar />
                <InternationalShippingMississaugaPage />
                <Footer />
              </>
            } />
            <Route path="/international-shipping-surrey" element={
              <>
                <Navbar />
                <InternationalShippingSurreyPage />
                <Footer />
              </>
            } />
            <Route path="/international-shipping-vancouver" element={
              <>
                <Navbar />
                <InternationalShippingVancouverPage />
                <Footer />
              </>
            } />
            <Route path="/international-shipping-nova-scotia" element={
              <>
                <Navbar />
                <InternationalShippingNovaScotiaPage />
                <Footer />
              </>
            } />
            <Route path="/cheap-shipping-canada-to-india" element={
              <>
                <Navbar />
                <CheapShippingCanadaToIndiaPage />
                <Footer />
              </>
            } />
            <Route path="/relocation-shipping-canada-to-india" element={
              <>
                <Navbar />
                <RelocationShippingCanadaToIndiaPage />
                <Footer />
              </>
            } />
            <Route path="/shipping-cost-canada-to-india" element={
              <>
                <Navbar />
                <ShippingCostCanadaToIndiaPage />
                <Footer />
              </>
            } />
            <Route path="/track-shipment" element={
              <>
                <Navbar />
                <TrackShipmentPage />
                <Footer />
              </>
            } />
            <Route path="/drop-off-locations" element={
              <>
                <Navbar />
                <DropOffLocationsPage />
                <Footer />
              </>
            } />
            <Route path="/services" element={
              <>
                <Navbar />
                <ServicesPage />
                <Footer />
              </>
            } />

            {/* New SEO Pages */}
            <Route path="/documents-to-india-from-canada" element={<><Navbar /><DocumentsToIndiaPage /><Footer /></>} />
            <Route path="/ship-suitcase-canada-to-india" element={<><Navbar /><ShipSuitcaseCanadaToIndiaPage /><Footer /></>} />
            <Route path="/student-shipping-canada-to-india" element={<><Navbar /><StudentShippingCanadaToIndiaPage /><Footer /></>} />
            <Route path="/23kg-parcel-canada-to-india" element={<><Navbar /><TwentyThreeKgParcelPage /><Footer /></>} />
            
            {/* City-to-India Routes */}
            <Route path="/brampton-to-india-courier" element={<><Navbar /><BramptonToIndiaPage /><Footer /></>} />
            <Route path="/toronto-to-india-courier" element={<><Navbar /><TorontoToIndiaPage /><Footer /></>} />
            <Route path="/mississauga-to-india-courier" element={<><Navbar /><MississaugaToIndiaPage /><Footer /></>} />
            <Route path="/hamilton-to-india-courier" element={<><Navbar /><HamiltonToIndiaPage /><Footer /></>} />
            <Route path="/vaughan-to-india-courier" element={<><Navbar /><VaughanToIndiaPage /><Footer /></>} />
            <Route path="/markham-to-india-courier" element={<><Navbar /><MarkhamToIndiaPage /><Footer /></>} />
            <Route path="/richmond-hill-to-india-courier" element={<><Navbar /><RichmondHillToIndiaPage /><Footer /></>} />
            <Route path="/kitchener-to-india-courier" element={<><Navbar /><KitchenerToIndiaPage /><Footer /></>} />
            <Route path="/waterloo-to-india-courier" element={<><Navbar /><WaterlooToIndiaPage /><Footer /></>} />
            <Route path="/oakville-to-india-courier" element={<><Navbar /><OakvilleToIndiaPage /><Footer /></>} />
            <Route path="/calgary-to-india-courier" element={<><Navbar /><CalgaryToIndiaPage /><Footer /></>} />
            
            {/* International Destinations */}
            <Route path="/shipping-canada-to-usa" element={<><Navbar /><ShippingCanadaToUSAPage /><Footer /></>} />
            <Route path="/shipping-canada-to-uk" element={<><Navbar /><ShippingCanadaToUKPage /><Footer /></>} />
            <Route path="/shipping-canada-to-uae" element={<><Navbar /><ShippingCanadaToUAEPage /><Footer /></>} />
            <Route path="/shipping-canada-to-australia" element={<><Navbar /><ShippingCanadaToAustraliaPage /><Footer /></>} />
            <Route path="/shipping-canada-to-pakistan" element={<><Navbar /><ShippingCanadaToPakistanPage /><Footer /></>} />
            <Route path="/shipping-canada-to-nepal" element={<><Navbar /><ShippingCanadaToNepalPage /><Footer /></>} />
            <Route path="/shipping-canada-to-bangladesh" element={<><Navbar /><ShippingCanadaToBangladeshPage /><Footer /></>} />
            <Route path="/shipping-canada-to-germany" element={<><Navbar /><ShippingCanadaToGermanyPage /><Footer /></>} />
            <Route path="/shipping-canada-to-france" element={<><Navbar /><ShippingCanadaToFrancePage /><Footer /></>} />
            <Route path="/shipping-canada-to-ukraine" element={<><Navbar /><ShippingCanadaToUkrainePage /><Footer /></>} />
            <Route path="/shipping-canada-to-philippines" element={<><Navbar /><ShippingCanadaToPhilippinesPage /><Footer /></>} />
            <Route path="/shipping-canada-to-africa" element={<><Navbar /><ShippingCanadaToAfricaPage /><Footer /></>} />
            <Route path="/shipping-canada-to-caribbean" element={<><Navbar /><ShippingCanadaToCaribbeanPage /><Footer /></>} />
            
            {/* Specialized Services */}
            <Route path="/excess-baggage-shipping-canada-to-india" element={<><Navbar /><ExcessBaggageShippingPage /><Footer /></>} />
            <Route path="/household-goods-shipping-canada-to-india" element={<><Navbar /><HouseholdGoodsShippingPage /><Footer /></>} />
            <Route path="/business-ecommerce-shipping" element={<><Navbar /><BusinessShippingPage /><Footer /></>} />
            <Route path="/shipping-supplements-protein" element={<><Navbar /><SupplementsProteinShippingPage /><Footer /></>} />
            <Route path="/electronics-battery-shipping" element={<><Navbar /><ElectronicsBatteryShippingPage /><Footer /></>} />
            <Route path="/international-perfume-shipping" element={<><Navbar /><InternationalPerfumeShippingPage /><Footer /></>} />
            <Route path="/international-barrel-shipping" element={<><Navbar /><InternationalBarrelShippingPage /><Footer /></>} />
            
            {/* Guide Pages */}
            <Route path="/shipping-cost-guide-canada-to-india" element={<><Navbar /><ShippingCostGuidePage /><Footer /></>} />
            <Route path="/customs-duties-guide-india" element={<><Navbar /><CustomsDutiesGuidePage /><Footer /></>} />
            <Route path="/packaging-guide-international-shipping" element={<><Navbar /><PackagingGuidePage /><Footer /></>} />
            <Route path="/prohibited-items-international-shipping" element={<><Navbar /><ProhibitedItemsGuidePage /><Footer /></>} />

            {/* Document Routes - Clean layout without Navbar, print-friendly */}
            <Route path="/privacy-policy" element={
              <DocumentLayout>
                <PrivacyPolicyPage />
              </DocumentLayout>
            } />
            <Route path="/terms-conditions" element={
              <DocumentLayout>
                <TermsConditionsPage />
              </DocumentLayout>
            } />
            <Route path="/customs-declaration" element={
              <DocumentLayout>
                <CustomsDeclarationPage />
              </DocumentLayout>
            } />
            <Route path="/sender-receiver-form" element={
              <DocumentLayout>
                <SenderReceiverFormPage />
              </DocumentLayout>
            } />
            <Route path="/shipping-destinations" element={
              <>
                <Navbar />
                <ShippingDestinationsPage />
                <Footer />
              </>
            } />
            <Route path="/contact" element={
              <DocumentLayout>
                <ContactPage />
              </DocumentLayout>
            } />
            <Route path="/schedule-pickup" element={
              <DocumentLayout>
                <SchedulePickupPage />
              </DocumentLayout>
            } />
            <Route path="/blog" element={
              <>
                <Navbar />
                <BlogListPage />
                <Footer />
              </>
            } />
            <Route path="/blog/:slug" element={
              <>
                <Navbar />
                <BlogArticlePage />
                <Footer />
              </>
            } />
          </Routes>
        </div>
        <Toaster />
      </div>
    </Router>
  );
}

export default App;